<template>
    <div class="page-table mainDiv" id="affix-container">
        <div class="card-base baslikBg animated fadeInUp">
            {{$t("src.views.apps.haberler.kategori.tanimlama.mainBaslik")}}
        </div>
        <el-row :gutter="10">
            <el-col :lg="18" :md="18" :sm="24" :xs="24">
                <div class="page-header card-base card-shadow--medium animated fadeInUp">
                    <el-table
                            :data="kategoriListe"
                            style="width: 100%">
                        <el-table-column
                                label="Sıra"
                                type="index"
                                width="50">
                        </el-table-column>
                        <el-table-column
                                prop="baslik"
                                label="Başlık"
                                width="auto">
                        </el-table-column>
                        <el-table-column
                                prop="menuDurum"
                                label="Menü Durum"
                                width="auto">
                        </el-table-column>
                        <el-table-column
                                label="İşlem"
                                align="right"
                                width="auto">
                            <template slot-scope="scope">
                                <el-tooltip :content='$t("src.views.apps.haberler.kategori.liste.duzenle")' :open-delay="500"
                                            placement="bottom">
                                    <el-button
                                            v-on:click="selectionIndex=scope.$index; selection=scope.row; updateStart(scope.row); "
                                            type="text"
                                            class="buttonEdit"
                                            icon="el-icon-edit">
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip :content='$t("src.views.apps.haberler.kategori.liste.sil")' :open-delay="500"
                                            placement="bottom">
                                    <el-button
                                            v-on:click="dialogVisible = true; selection=scope.row; selectionIndex=scope.$index"
                                            type="text"
                                            class="buttonDel"
                                            icon="mdi mdi-delete mdi-24px">
                                    </el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-col>
            <el-col :lg="6" :md="6" :sm="24" :xs="24">
                <div class="card-base card-shadow--medium demo-box bg-white animated fadeInUp">
                    <el-form status-icon :model="kategoriForm" :rules="rulesKategori" ref="kategoriForm" class="demo-ruleForm">
                        <div>
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item
                                            :label='$t("src.views.apps.haberler.tanimlama.baslik")'
                                            prop="baslik">:
                                        <div v-if="linkVisible" style="float: right; display: flex">
                                            <div v-if="!VisibleA">
                                                <el-link target="_blank" :underline="false"
                                                         :href="this.path">
                                                    {{this.path}}{{this.kategoriForm.link}}
                                                </el-link>
                                            </div>
                                            <el-button v-if="duzenleBtnVisible"
                                                       style="margin-left: 10px; margin-bottom: 5px"
                                                       v-on:click="VisibleA = true; duzenleBtnVisible=false"
                                                       size="mini">Düzenle
                                            </el-button>
                                            <span v-if="VisibleA">{{this.path}}</span>
                                            <el-input v-if="VisibleA" v-model="kategoriForm.link"
                                                      v-on:change="$store.commit('changeTabsClose', false);linkChange = false"
                                                      v-on:blur="linkTespitLink();VisibleA=false; duzenleBtnVisible=true"
                                                      style="width: 50%" size="mini"></el-input>
                                        </div>
                                        <el-input
                                                :disabled="disabled"
                                                v-model="kategoriForm.baslik"
                                                v-on:change="linkTespit(); $store.commit('changeTabsClose', false);"
                                                :placeholder='$t("src.views.apps.haberler.tanimlama.baslikPlace")'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item :label='$t("src.views.apps.haberler.kategori.tanimlama.menu")'>:
                                        <el-select
                                                v-on:change="$store.commit('changeTabsClose', false)"
                                                v-model="kategoriForm.menu"
                                                :placeholder='$t("src.views.apps.haberler.kategori.tanimlama.menuPlace")'
                                                style="width: 100%">
                                            <el-option value="0" label="Gösterme">Gösterme</el-option>
                                            <el-option value="1" label="Göster">Göster</el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                        <el-row class="col-p">
                            <el-form-item>
                                <el-button v-if="btnVisible" size="small" v-on:click="kategoriTanimlama('kategoriForm')"
                                           type="primary">
                                    {{$t('src.views.apps.haberler.kategori.tanimlama.kategoriEkle')}}
                                </el-button>
                                <el-button v-else size="small" v-on:click="guncelleme('kategoriForm')" type="primary">
                                    {{$t('src.views.apps.haberler.kategori.tanimlama.kategoriGuncelle')}}
                                </el-button>
                                <el-button v-if="!btnVisible" size="small" v-on:click="vazgec('kategoriForm')">
                                    Vazgeç
                                </el-button>
                            </el-form-item>
                        </el-row>
                    </el-form>
                </div>
            </el-col>
        </el-row>
        <el-dialog
                :title='$t("src.views.apps.haberler.liste.uyari")'
                :visible.sync="dialogVisible"
                width="30%"
                center>
            <span>"{{selection["baslik"]}}" {{$t('src.views.apps.haberler.kategori.tanimlama.sil')}}</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="sil(selection,selectionIndex,kategoriListe), dialogVisible = false"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-close"
                               @click="dialogVisible = false"></el-button>
                </span>
        </el-dialog>
    </div>
</template>

<script>

    import haberKategoriService from '../../../../WSProvider/HaberKategoriService'
    import haberService from '../../../../WSProvider/HaberService'
    import seoService from '../../../../WSProvider/SeoService'
    import notification from '../../../../notification'
    import JQuery from 'jquery';

    let $ = JQuery;
    let base64 = require('base64_js');
    let userDataSidas = "";
    export default {
        name: "KategoriTanimlama",
        mounted() {
            let state = false;
            if (localStorage.getItem("userDataSidas")) {
                userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
                if (userDataSidas["tur"]) {
                    if (userDataSidas["tur"] === '1' || userDataSidas["tur"] === '2')
                        state = true;
                }
            }
            if (!state) {
                this.$store.commit('setLogout');
                this.$router.push("/login");
            } else {
                this.getKategoriList();
            }
        },
        data() {
            return {
                kategoriListe: [],
                path: haberService.path,
                updateKodu: '',
                btnVisible: true,
                selection: '',
                selectionIndex: '',
                dialogVisible: false,
                duzenleBtnVisible: true,
                VisibleA: false,
                linkVisible: false,
                linkChange: true,
                disabled: false,
                kategoriForm: {
                    baslik: '',
                    link: '',
                    menu: '0',
                },
                rulesKategori: {
                    baslik: [{
                        required: true,
                        message: "Lütfen Başlık Giriniz",
                        trigger: 'blur'
                    }],
                },
            }
        },
        methods: {
            linkTespitLink() {
                let self = this;
                if (this.kategoriForm.link) {
                    seoService.linkKontrol(self.kategoriForm.link.replace("'", "").substring(0, 55)).then((response) => {
                        if (response.status === 200) {
                            self.kategoriForm.link = response.data;
                        } else {
                            notification.Status(response.status, this)
                        }
                    })
                }
            },
            linkTespit() {
                let self = this;
                if (this.kategoriForm.baslik && this.linkChange) {
                    seoService.linkKontrol(this.kategoriForm.baslik.replace("'", "").substring(0, 55)).then((response) => {
                        if (self.kategoriForm.baslik) {
                            if (response.status === 200) {
                                self.linkVisible = true;
                                self.kategoriForm.link = response.data;
                            }
                        } else if (!self.kategoriForm.baslik) {
                            self.linkVisible = false;
                            self.kategoriForm.link = '';
                        }
                    })
                }
            },
            getKategoriList() {
                haberKategoriService.kategoriList(0).then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            switch (e.menu) {
                                case '0':
                                    e.menuDurum = 'Gösterme';
                                    break;
                                case '1':
                                    e.menuDurum = 'Göster';
                                    break;
                            }
                        });
                        this.kategoriListe = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            updateStart(scope) {
                this.kategoriForm.baslik = scope.baslik;
                this.kategoriForm.menu = scope.menu;
                this.updateKodu = scope.hkategoriKodu;
                this.btnVisible = false;
            },
            vazgec(formName) {
                this.$refs[formName].resetFields();
                this.btnVisible = true;
            },

            kategoriTanimlama(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        haberKategoriService.kategoriTanimlama(this.kategoriForm.link,this.kategoriForm.baslik, this.kategoriForm.menu).then((response) => {
                            if (response.status === 200) {
                                switch (response.data.menu) {
                                    case '0':
                                        response.data.menuDurum = 'Gösterme';
                                        break;
                                    case '1':
                                        response.data.menuDurum = 'Göster';
                                        window.location.reload();
                                        break;
                                }
                                this.kategoriListe.push(response.data);
                                notification.Status('success', this, 'Kategori başarıyla eklendi.');
                                this.$refs[formName].resetFields();
                                this.kategoriForm.link = '';
                                this.linkVisible = false;
                                this.VisibleA = false;
                            } else if (response.status === 200) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir kategori zaten mevcut');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            },
            guncelleme(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        haberKategoriService.kategoriGuncelle(this.updateKodu, this.kategoriForm.baslik, this.kategoriForm.menu).then((response) => {
                            if (response.status === 200) {
                                switch (response.data.menu) {
                                    case '0':
                                        response.data.menuDurum = 'Gösterme';
                                        break;
                                    case '1':
                                        response.data.menuDurum = 'Göster';
                                        window.location.reload();
                                        break;
                                }
                                this.kategoriListe.splice(this.selectionIndex, 1);
                                this.kategoriListe.splice(this.selectionIndex, 0, {
                                    baslik: response.data.baslik,
                                    menu: response.data.menu,
                                    menuDurum: response.data.menuDurum,
                                    hkategoriKodu: response.data.hkategoriKodu
                                });
                                notification.Status('success', this, 'Kategori başarıyla güncellendi...');
                                this.$refs[formName].resetFields();
                                this.kategoriForm.link = '';
                                this.linkVisible = false;
                                this.VisibleA = false;
                                this.btnVisible = true;
                            } else if (response.status === 200) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir kategori zaten mevcut');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            },
            sil(selection, index, list) {
                haberKategoriService.kategoriKaldir(selection.hkategoriKodu).then((response) => {
                    if (response.status === 200) {
                        notification.Status('success', this, 'Kategori başarıyla silindi.');
                        list.splice(index, 1);
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
        }
    }

</script>


<style scoped>

</style>